import * as types from '@/store/mutation-types'
    export default {
    namespaced: true,

    state: {
        info: {},
        centerId: null,
        isAuth: false
    },

    actions: {
        login ({ commit }, { userName, password }) {
            return window.axios.post(`/assistant/${userName}/auth`, null,
                {
                    headers: {
                        'X-Password': password || ''
                    }
                })
                .then((response) => {
                    const auth = {
                        password: password,
                        Id: response.data.Id,
                        BusNo: response.data.BusNo,
                        DriverName: response.data.DriverName,
                        DriverPhone: response.data.DriverPhone,
                        AssistantName: response.data.AssistantName,
                        CenterId: response.data.CenterId,
                        Student: response.data.Student ? response.data.Student : []
                    }
                    localStorage.setItem('isAuth', true)
                    commit(types.LOGIN, auth)
                    return auth
                })
        },

        logout ({ commit }) {
            localStorage.removeItem('auth')
			localStorage.removeItem('isAuth')
            localStorage.clear()
			commit(types.LOGOUT)
        }
    },

    mutations: {
        [types.LOGIN] (state, payload) {
            state.info.BusNo = payload.BusNo
			state.info.DriverName = payload.DriverName
			state.info.DriverPhone = payload.DriverPhone
			state.info.CenterId = payload.CenterId
            state.info.AssistantName = payload.AssistantName
            state.info.students = payload.Student
            state.info.CenterId = payload.CenterId
            state.info.busId = payload.Id

            state.isAuth = true
			window.axios.defaults.headers['X-Password'] = payload.password
        },

        [types.LOGOUT] (state) {
			state.isAuth = false
			state.info = {}
            localStorage.clear()
		}
    }
}
